import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable, toJS } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Tabela} from "../../comum/components/Tabela";
import ContratacoesConcluidasStore from "../stores/ContratacoesConcluidasStore";
import {
    formatarDataISO8601, statusSolicitacaoFormatter, motivoContratacaoFormatter, ordenarData,
    createSelectOptions, slaFormatter, formatarCpf, nullable, formatarNomeProduto
} from "../../../utils/formatar";
import {sortAlphaNum} from "../../../utils/ordenar";
import {motivoContratacaoEnum} from "../../../utils/enums";
import {Validacao} from "../../comum/components/Validacao";
import DatePicker from "react-datepicker";
import {Col, FormGroup, Label, Row} from "reactstrap";
import Select from "react-select";
import TabelaFiltro from "../../comum/components/TabelaFiltro";
import {ContratacoesFiltro} from "../components/ContratacoesFiltro";
import {TabelaFluxo} from "../../comum/components/TabelaFluxo";

const COLUNAS = [
    {
        field: "nomeProfissional",
        label: "Nome do Profissional"
    },{
        field: "cpfProfissional",
        label: "CPF do Profissional"
    },{
        field: "idSolicitacaoExibicao",
        label: "Solicitação",
        funcaoOrdenacao: sortAlphaNum.bind("idSolicitacaoExibicao")
    },{
        field: "solicitante",
        label: "Socilitante"
    },{
        field: "gestor",
        label: "Gestor"
    },{
        field: "cargo",
        label: "Cargo"
    },{
        field: "motivoContratacao",
        label: "Motivo Contratação",
        dataFormat: motivoContratacaoFormatter
    },{
        field: "justificativa",
        label: "Justificativa"
    },{
        field: "produto",
        label: "Projeto/centro de resultado/finalidade",
        dataFormat: formatarNomeProduto
    },{
        field: "dataInicio",
        label: "Data de Início",
        //dataFormat: formatarDataISO8601,
        funcaoOrdenacao: ordenarData.bind("dataInicio")
    },{
        field: "dataTermino",
        label: "Data de Término",
        //dataFormat: formatarDataISO8601,
        funcaoOrdenacao: ordenarData.bind("dataTermino")
    },{
        field: "empresa",
        label: "ETT"
    },{
        field: "statusSolicitacaoCalculado",
        label: "Status",
        dataFormat: statusSolicitacaoFormatter
    }
];

@inject("store")
@DataWrapper
@observer
export class ContratacoesConcluidas extends Component {
    constructor(props) {
        super(props);
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        this.modalStore                = this.props.store.modalStore;
        this.loginStore                 = this.props.store.loginStore;
        /* Selecionar Controller */
        this.controller                 = new ContratacoesConcluidasStore();
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Contratações concluídas");

        // tratamento para visão mobile
        if (this.appStore.width < 768) {
            this.controller.carregarTabela();
        }

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            },{
                label: "Filtrar",
                icone: "search",
                acao: () => this.modalStore.toggleModal('filtrar')
            }
        ]);
    }

    obterTituloMobile = (objeto) => {
        return  (objeto.idSolicitacaoExibicao != null ? "#" + objeto.idSolicitacaoExibicao : "") + (objeto.cargo != null ? " - " + objeto.cargo : "") + (objeto.nomeProduto != null ? " para " + objeto.nomeProduto : "");
    };



    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "Nome profissional: " + nullable(objeto.nomeProfissional)}<br/>
                { "CPF: " + nullable(formatarCpf(objeto.cpfProfissional))}<br/>
                { "Solicitante: " + nullable(objeto.solicitante)}<br/>
                { "Gestor: " +  nullable(objeto.gestor)}<br/>
                { "Cargo: " +  nullable(objeto.cargo)}<br/>
                { "Motivo contratação: " + nullable(motivoContratacaoFormatter(objeto.motivoContratacao))}<br/>
                { "Justificativa: " + nullable(objeto.justificativa)}<br/>
                { "Vigência: " + nullable(objeto.dataInicio)}
                { " à " + nullable(objeto.dataTermino)}<br/>
                { "Empresa: " + nullable(objeto.empresa)}<br/>
                { "Status: " + nullable(objeto.statusSolicitacaoCalculado)}<br/>
            </div>
        )
    };

    render() {
        let acoesItens = [];
        if(this.loginStore.isPerfilAdministradorLogado || this.loginStore.podeSolicitarMOT) {
            acoesItens = ["visualizarControle", "clonar"];
        } else {
            acoesItens = ["visualizarControle"];
        }

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        {this.appStore.width > 768 && <ContratacoesFiltro controller={this.controller} filtrarStatus={true} filtrarSolicitacao={true} limite={350} quantidadeTotal={this.controller.quantidadeTotal}/>}
                        <TabelaFluxo
                            keyField={"idSolicitacaoExibicao"}
                            nomeFluxo={'Solicitação'}
                            parametroVisualizar={"idSolicitacaoExibicao"}
                            parametroClonar={'idSolicitacao'}
                            temBusca={true}
                            habilitarSelecaoMultipla={true}
                            listaItens={toJS(this.controller.contratacoesConcluidasLista)}
                            colunas={COLUNAS}
                            acoesItens={acoesItens}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            onChange={(value) => this.controller.setLista(value)}
                            onCardClick={this.props.onCardClick}
                            loading={this.controller.loading}
                            mobileFilter={<ContratacoesFiltro controller={this.controller} filtrarStatus={true}/>}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

